// utils/environmentDetector.js
export const isElectron = (): boolean => {
  // Check user agent
  const userAgent = navigator.userAgent.toLowerCase();
  const hasElectronUA = userAgent.includes("electron");

  const hasElectronVersion =
    typeof window !== "undefined" && (window as any).versions?.electron?.();

  return hasElectronUA && hasElectronVersion;
};

export const isQashqoolMobile = (): boolean => {
  return window.location.hostname === "mobile.qashqool.com";
};

export const isXvast = (): boolean => {
  return window.navigator.userAgent.indexOf("Xvast") !== -1;
};
